<template>
  <div :ref="'rm_' + index" class="rm">
    <div v-if="selected == index" class="rm-form row">
      
      <div>
        <div class="row mb-15">
          <input
            v-model="form.first_name"
            class="input-text"
            placeholder="First Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-model="form.last_name"
            class="input-text"
            placeholder="Last Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-if="warn_email"
            v-model="form.email_address"
            class="input-text warn-input"
            placeholder="Email"
            type="text"
          />
          <input
            v-else
            v-model="form.email_address"
            class="input-text"
            placeholder="Email"
            type="text"
          />
          <transition><p v-if="warn_email" id="warn_email" class="warn">You must provide an email address to continue.</p></transition>
        </div>
        <div class="row mb-15">
          <input
            v-if="warn_zip"
            v-model="form.zip_code"
            class="input-text warn-input"
            placeholder="ZIP / Postal Code"
            type="text"
          />
          <input
            v-else
            v-model="form.zip_code"
            class="input-text"
            placeholder="ZIP / Postal Code"
            type="text"
          />
          <transition><p v-if="warn_zip" id="warn_zip" class="warn">You must provide a ZIP code to continue.</p></transition>
        </div>

        <div class="row mb-15 checkbox-row">
          <label for="checkbox-marketing">
            <input
              id="checkbox-marketing"
              v-model="form.signUp"
              type="checkbox"
            />
            <span class="shadow">I would like to be among the first to receive advance notice of exclusive events, invitation-only offers, and noteworthy updates from Rancho Bernado Inn & JC Resorts.</span>
          </label>
          <label for="checkbox-consent">
            <input
              id="checkbox-consent"
              v-model="form.consent"
              type="checkbox"
            />
            <span class="shadow">By signing up, I agree to Rancho Bernardo Inn’s <a href="https://www.ranchobernardoinn.com/terms-of-use">Terms & Conditions.</a> I also acknowledge Rancho Bernardo Inn’s <a href="https://www.ranchobernardoinn.com/privacy-policy">Privacy Policy</a> and the California Notice of Financial Incentive.</span>
          </label>
          <transition><p v-if="warn_consent" id="warn_consent" class="warn">You must accept these terms to continue.</p></transition>
        </div>
      </div>
      <!-- END SPECIAL SIGN UP METHOD -->

      <div>
        <button
          class="btn btnSpecial"
          type="button"
          @click="emitRegistrationMethodData()"
        >
          Continue
        </button>
      </div>
      <p class="bottom-link">
        To learn more about how we use your personal information, visit us online at…<a href="https://www.ranchobernardoinn.com/privacy-policy">https://www.ranchobernardoinn.com/privacy-policy</a>
      </p>
      <div
        v-if="selected_tos == index"
        class="terms-of-service text-left pt-20"
      >
        <div v-html="registration_method.terms_of_service"></div>
        <div class="mt-30 text-center">
          <button class="btn-close" @click="selectTermsOfService(null)">
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- rm -->
</template>
<script>
import Axios from "axios";
import {HTTP} from '@/utilities/http'

export default {
  name: "registration_method",
  props: [
    "index",
    "selected",
    "selected_tos",
    "color_background_button",
    "color_text_button",
    "registration_method",
  ],
  data() {
    return {
      selected_error: false,
      warn_email: false,
      warn_zip: false,
      warn_consent: false,
      form: {
        first_name: "",
        last_name: "",
        room_number: "",
        email_address: "",
        zip_code: "",
        signUp: 0,
        consent: 0
      },
      revinate: {
        list_token: "bab36dc5-33f7-4985-a0db-547e28fb3e8c",
        url: "https://contact-api.inguest.com/api/add-contacts-to-lists",
      },
    };
  },
  mounted() {
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription: function (rm) {

    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod: function (index) {
      this.$emit("changeSelected", index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService: function (index) {
      this.$emit("changeSelectedTOS", index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: function () {

      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: this.registration_method.id,
        email_address: null,
        last_name: null,
        room_number: null,
      };

      if(!this.form.email_address) {
        this.warn_email = true
      }

      if(!this.form.zip_code) {
        this.warn_zip = true
      }

      if(this.form.email_address !== '' && this.form.zip_code !== '') {
        this.warn_email = false;
        this.warn_zip = false;
        emitted.registration_method_id = 3;
        emitted.email_address = this.form.email_address;
        emitted.last_name = this.form.last_name;
        emitted.first_name = this.form.first_name;
        emitted.zip_code = this.form.zip_code;

        if(!this.form.consent) {
          this.warn_consent = true
        }

        if(this.form.consent && this.form.signUp){
          this.warn_consent = false
          const revinate_data = {
            tokens: [this.revinate.list_token],
            contacts: [
              { email: this.form.email_address, first_name: this.form.first_name, last_name: this.form.last_name, zip: this.form.zip_code },
            ]
          };
          Axios.post(this.revinate.url,revinate_data).then(response => {
            this.$emit('emitRegistrationMethodData', emitted);
          }).catch( error => {
            this.$emit('error', 'Error registering with email address.');
          });
        } else {
          if(this.form.consent) {
            this.$emit('emitRegistrationMethodData', emitted);
          }
        }   
      } 
    },
  },
};
</script>
<style>

.v-enter-active,
.v-leave-active {
  transition: opacity 1.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.shadow {
  text-shadow: 0px 0px 10px black;
}

#logo {
  padding: 3% !important;
}

.btnAlt {
  background: #767575ab !important;
}

.btnSpecial {
  text-transform: uppercase; 
  font-size: 12px !important;
  height: 65px;
  margin-bottom: 10px;
  -webkit-filter: brightness(1);
   filter: brightness(1);
}

.btnSpecial:hover {
  -webkit-filter: brightness(1.2);
   filter: brightness(1.2);
}

input {
  color: white;
}

.warn-input {
    border-top: 2px solid #d7403a !important;
    border-left: 2px solid #c22b51 !important;
    border-right: 2px solid #c22b51 !important;
    background: #f9f9f9;
    position: relative;
    z-index: 1;
}

.warn {
  background: #FFFFFF;
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0)), to(rgba(199, 113, 128, 1)));
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(199, 113, 128, 1) 100%);
  color: #ffcfcf;
  border-radius: 8px;
  padding: 50px 0 30px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 1px #864a4a;
  position: relative;
  top: -30px;
}

#rms {max-width: 550px;}

#logo img {
  max-width: 375px;
}

.rm a,
.rm span.text-link {
  color:  white;
  text-decoration: underline;
  cursor: pointer;
}

.rm .help-text {
  color: #000000;
  padding: 5px 0;
  font-size: 14px;
  font-style: italic;
  text-align: center;
  display: block;
}

.rm .error-text {
  text-transform: uppercase;
  position: absolute;
  line-height: 1;
  right: 12px;
  top: 12px;
  padding: 8px 8px 7px 8px;
  background: red;
  color: #ffffff;
  border-radius: 3px;
  text-align: left;
  font-weight: bold;
  font-size: 12px;
}

.rm:last-child {
  border: none;
}

.rm .rm-header {
  border-top-width: 1px;
  border-top-style: solid;
  cursor: pointer;
}

.rm .rm-form {
  background: none;
  width: 75%;
  margin: auto;
  border: none;
}


.rm .input-text {
  border-radius: 10px;
  border: none;
  border-bottom: 1px solid #cccccc;
  overflow: visible;
  width: 100%;
  padding: 15px;
  font-size: 16px;
  text-align: left;
}

.rm .btn {
  background: #004e5e;
  border: 2px solid #004e5e;
  color: white;
  border-radius: 10px;
}

.rm .btn:hover, .btnSpecial:hover {
  -webkit-filter: brightness(1.2);
  filter: brightness(1.2);
  opacity: 1;
}

.rm .btn {
  width: 100%;
  padding: 20px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
}

.rm .btn.rounded {
  border-radius: 6px;
}

.rm label {
  display: inline-block;
  padding: 0px;
  width: 100%;
  font-size: 18px;
  margin: 10px 0;
}

.rm label span {
  font-size: 14px;
  font-weight: bold;
  padding-left: 6px;
  float: left;
  width: 88%;
}

.rm .input-radio {
  display: inline-block;
  padding: 10px;
}

@media screen and (max-device-width: 800px) {
  .rm .rm-form {
    width: 75%;
    margin: 0 auto;
  }
}

.checkbox-row {
  text-align: left;
}

.checkbox-row input {
    margin-right: 10px;
    border-radius: 5px;
    float: left;
    width: 5%;
}

.input-text {
  text-align: center;
}

.top-btn {
  margin-top: 1rem;
}

.bottom-link, .bottom-link a, .bottom-link a:visited, .rm span.text-link {
  color: white;
  font-size: 12px;
}
</style>
